import type {CompStructure, Pointer, PossibleViewModes} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'

interface ComponentAfterAddData {
    componentType: string
    compToAddPointer: Pointer
    componentDefinition: CompStructure
    optionalCustomId?: string
    mappers: any
    containerPointer: Pointer
    componentIndex?: number
}

interface ComponentAfterRootAddData {
    componentType: string
    compToAddPointer: Pointer
    componentDefinition: CompStructure
    containerPointer: Pointer
    viewMode?: PossibleViewModes
    componentIndex?: number
}
interface ComponentBeforeRootAddData {
    compToAddPointer: Pointer
    componentDefinition: CompStructure
    containerPointer: Pointer
    optionalCustomId?: string
    optionalIndex?: string
    componentIndex?: number
}
export interface ComponentAfterRootAddDataFromExtEvent
    extends ComponentAfterRootAddData,
        HookEventData<'root_component_after_add_from_ext'> {}
export interface ComponentBeforeRootAddDataFromExtEvent
    extends ComponentBeforeRootAddData,
        HookEventData<'root_component_before_add_from_ext'> {}
export interface ComponentAfterAddDataEvent extends ComponentAfterAddData, HookEventData<'component_after_add'> {}

export interface RefComponentAfterAddDataEvent
    extends ComponentAfterAddData,
        HookEventData<'ref_component_after_add'> {}
export interface ComponentAfterAddDataFromExtEvent
    extends ComponentAfterAddData,
        HookEventData<'component_after_add_from_ext'> {}
export interface AdjustComponentLayoutFromExtEvent
    extends ComponentAfterAddData,
        HookEventData<'adjust_component_layout_from_ext'> {}

interface ComponentBeforeAddData {
    componentType: string
    compToAddPointer: Pointer
    componentDefinition: CompStructure
    optionalCustomId?: string
    mappers: any
    containerPointer: Pointer
    isPage: boolean
    isAncestorsChecked: boolean
    componentIndex?: number
}
export interface ComponentBeforeAddDataFromExt
    extends ComponentBeforeAddData,
        HookEventData<'component_before_add_from_ext'> {}
export interface ComponentBeforeAddDataEvent extends ComponentBeforeAddData, HookEventData<'component_before_add'> {}
export interface ComponentAfterRootAddDataEvent
    extends ComponentAfterRootAddData,
        HookEventData<'root_component_after_add'> {}

interface SerializeDataAfterEventData {
    componentPointer: Pointer
    componentDefinition: CompStructure
    flags: any
    pageId: string
}
export interface SerializeDataAfterEvent extends SerializeDataAfterEventData, HookEventData<'serialize_data_after'> {}

interface ComponentDuplicateData {
    compRefToAdd: Pointer
    componentPointer: Pointer
    newContainerPointer: Pointer
    customId?: string
}
export interface ComponentDuplicateEvent extends ComponentDuplicateData, HookEventData<'component_duplicate'> {}

export const COMPONENTS_HOOKS = {
    ADD_COMPONENT: {
        BEFORE: createHookDefinition<'component_before_add', ComponentBeforeAddData>('component_before_add'),
        BEFORE_FROM_EXT: createHookDefinition<'component_before_add_from_ext', ComponentBeforeAddDataFromExt>(
            'component_before_add_from_ext'
        ),
        AFTER: createHookDefinition<'component_after_add', ComponentAfterAddData>('component_after_add'),
        REF_COMPONENT_AFTER: createHookDefinition<'ref_component_after_add', RefComponentAfterAddDataEvent>(
            'ref_component_after_add'
        ),
        AFTER_FROM_EXT: createHookDefinition<'component_after_add_from_ext', ComponentAfterAddDataFromExtEvent>(
            'component_after_add_from_ext'
        ),
        ADJUST_COMP_LAYOUT: createHookDefinition<'adjust_component_layout_from_ext', AdjustComponentLayoutFromExtEvent>(
            'adjust_component_layout_from_ext'
        )
    },
    ADD_ROOT: {
        AFTER: createHookDefinition<'root_component_after_add', ComponentAfterRootAddData>('root_component_after_add'),
        AFTER_FROM_EXT: createHookDefinition<
            'root_component_after_add_from_ext',
            ComponentAfterRootAddDataFromExtEvent
        >('root_component_after_add_from_ext'),
        BEFORE_FROM_EXT: createHookDefinition<
            'root_component_before_add_from_ext',
            ComponentBeforeRootAddDataFromExtEvent
        >('root_component_before_add_from_ext')
    },
    DUPLICATE: {
        COMPONENT: createHookDefinition<'component_duplicate', ComponentDuplicateData>('component_duplicate')
    },
    SERIALIZE: {
        DATA_AFTER: createHookDefinition<'serialize_data_after', SerializeDataAfterEventData>('serialize_data_after')
    }
} as const
